var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-apex-charts',{attrs:{"type":"bar","height":"70","options":_vm.TotalVisitsChart.visitChart.chartOptions,"series":_vm.TotalVisitsChart.visitChart.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }